import { Box, Heading, Paragraph, TextButton } from '@zillow/constellation-10';

import type { RenterPaymentMethodInterface, RenterPaymentMethodTypeInterface } from '@renter-hub/models/Types';
import { getFormattedPaymentMethod } from '@common/constants/PaymentMethod';

interface Props {
  paymentMethod: RenterPaymentMethodInterface;
  onDeletePaymentMethodClick: () => void;
  paymentMethodTypes: RenterPaymentMethodTypeInterface[];
}

const PaymentMethodDetail = ({ paymentMethod, onDeletePaymentMethodClick, paymentMethodTypes }: Props) => {
  const selectedPaymentMethodType = paymentMethodTypes.find(
    (paymentMethodType) => paymentMethodType.type === paymentMethod.accountType,
  );

  if (!selectedPaymentMethodType) {
    return null;
  }

  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'token(spacing.md)' }}>
      <Box>
        <Heading level={2} textStyle="heading-xs">
          {paymentMethod.nickname || paymentMethod.displayName}
        </Heading>
        <Paragraph textStyle="body-lg">{`${getFormattedPaymentMethod(paymentMethod.accountType)} ending in ${
          paymentMethod.accountLast4
        }`}</Paragraph>
      </Box>
      <Box>
        <Paragraph>Rent charges (rent, move-in payments)</Paragraph>
        <Box>
          <Paragraph textStyle="body-bold">{selectedPaymentMethodType.rentFee}</Paragraph>
          <Paragraph textStyle="body-sm" css={{ color: 'text.subtle' }}>
            {' '}
            per transaction
          </Paragraph>
        </Box>
      </Box>
      <Box>
        <Paragraph>Other rental charges (utilities, late fees, etc)</Paragraph>
        <Box>
          <Paragraph textStyle="body-bold">{selectedPaymentMethodType.otherFee}</Paragraph>
          <Paragraph textStyle="body-sm" css={{ color: 'text.subtle' }}>
            {' '}
            per transaction
          </Paragraph>
        </Box>
      </Box>
      <TextButton css={{ alignSelf: 'flex-start' }} onClick={onDeletePaymentMethodClick}>
        Remove this payment method
      </TextButton>
    </Box>
  );
};

export default PaymentMethodDetail;
